var map = {
	"./Eva.jpg": "2acb",
	"./LizMar.jpg": "0e31",
	"./Magno2.jpg": "6399",
	"./avatar.png": "bb3c",
	"./fisio.png": "f613",
	"./perfilDenis.jpg": "c8f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b270";